import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBImg from './SBImg.vue'
import SBButton from './SBButton.vue'
import SBTitle from './SBTitle.vue'

@Component({
    components: {
        SBImg, SBButton, SBTitle
    },
})
export default class SBCategory extends Mixins(SBComponentVue) {
}
